import React from 'react';
import {observer} from 'mobx-react';
import {OrbitComponent} from '../../../base-components/orbit-component/orbit-component';
import {Button} from '../../../../basic-ui-components/button/base/button.component';
import {AppIdentifiers, AreaType} from "@sparkware/uc-sdk-core";

@observer
export class HelpButtonComponent extends OrbitComponent {

  private _openHelpWidget() {
    this.services.appLauncher.openHelpWidget({
      businessCorrelationID: this.services.tools.getGuid(),
      channel: {
        area: AreaType.PCHeader,
        element: AppIdentifiers.CRHelpCenter,
        source: AppIdentifiers.CasinoClient
      }
    });
  }

  handleClick(){
    this.services.analytics.sendAnalytics("Navigation", "Header", "Help");

    if (this.services.configuration.servicesConfigs.AppLauncher.apps.CR_HELP_CENTER.enabled) {
      this._openHelpWidget();
    } else {
      this.services.externalLinks.openHelpPage();
    }
  }

  render() {
    return (
      <Button
        className={"cy-header-help-button"}
        preset="flatStroked"
        icon={{Component: this.services.theme.currentTheme.icons.helpIcon}}
        onClick={this.handleClick.bind(this)}
        margin="0 0.4rem"
      />
    );
  }
}
